import "./style.css";

export const loadingBodyCX =
  "flex justify-center items-center h-[100vh] dark:bg-[#292929]";

export const loadingCX = "loader";
